<template>
  <v-stepper v-model="itemActive" vertical non-linear class="tabsStepper">
    <v-layout wrap align-start justify-start fill-height row>
      <v-flex v-show="false" class="tabs ">
        <v-stepper-step step="1" editable class="">
          <div class="persona-descripcion" />
        </v-stepper-step>
      </v-flex>

      <v-flex class="items" style="overflow-y: auto;">
        <v-stepper-content step="1">
          <v-card :class="classSteep">
            <!-- <copy-chip :text="instalacion.CorreoElectronico" class="subheading ml-0 mb-3"/> -->
            <div class="description mb-4">
              <v-layout v-for="(item, index) in telefonos" :key="index" class="mb-2" align-center justify-start>
                <div>Telf. {{ index+1 }}: {{ item }}</div>
                <v-flex class="ml-2">
                  <v-tooltip bottom>
                    <template v-slot:activator="{ on }">
                      <v-btn :href="`aocphone:0${ item.replace(/ |-/g, '') }`" target="_parent"
                             color="green" class="btn-dense"
                             fab dark icon small v-on="on" @click="sleepAskToLeave"
                      >
                        <v-icon dark>
                          phone
                        </v-icon>
                      </v-btn>
                    </template>
                    <span>{{ item }}</span>
                  </v-tooltip>
                </v-flex>
              </v-layout>

              <div v-html="instalacionDetalles" />
            </div>
          </v-card>
        </v-stepper-content>
      </v-flex>

      <inner-loading :visible="loading" />
    </v-layout>
  </v-stepper>
</template>

<script>
import InnerLoading from '@/components/InnerLoading'
import { Entities } from 'mixins/index.js'

export default {
  name: 'InstalacionDetalle',
  components: { InnerLoading },
  mixins: [ Entities ],
  props: {
    cliente: {
      type: [String, Number],
      default: '0'
    },
    instalacion: {
      type: [String, Number],
      default: '0'
    }
  },
  data () {
    return {
      loading: false,
      classSteep: 'pa-4 back',
      telefonos: [],
      instalacionDetalles: '',
      tabActive: null,
      itemActive: '1',
      searchText: null
    }
  },
  methods: {
    sleepAskToLeave () {
      let AskToLeave = this.$store.state.askToLeave
      this.$store.dispatch('AskToLeave', false)
      setTimeout(() => {
        this.$store.dispatch('AskToLeave', AskToLeave)
      }, 750)
    },
    clearn () {
      this.instalacionDetalles = ''
      this.telefonos = []
    },
    load (cliente, instalacion) {
      this.instalacionDetalles = ''
      this.telefonos = []
      if (cliente && instalacion) {
        this.loading = true
        this.axios
          .get(`${this.$apiUrl('instalacionEspecifica')}?cliente=${cliente}&instalacion=${instalacion}`,
            { headers: { 'Content-Type': 'application/json' } })
          .then(({ data }) => {
            if (data.Telefono1) { this.telefonos.push(data.Telefono1.replace(/ |-/g, '')) }
            if (data.Telefono2) { this.telefonos.push(data.Telefono2.replace(/ |-/g, '')) }
            this.instalacionDetalles = `Email:  ${data.Email || ''}\n`
            // this.instalacionDetalles += `Telefono1:  ${data.Telefono1 || ''}\nTelefono2:  ${data.Telefono2 || ''}\n`
            this.instalacionDetalles += `Web:  ${data.Web || ''}\n`
            this.instalacionDetalles += `Observaciones:  ${data.Observaciones || ''}\n\n`
            this.instalacionDetalles += `ObservacionesEspeciales:  ${data.ObservacionesEspeciales || ''}\n`
          })
          .catch(() => { })
          .then(() => { this.loading = false })
      }
    }
  }
}
</script>
